@use "@design/design-tokens/border-radius/border-radius" as *;

.errorStateRoot {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 20px;
  height: 100%;

  &.showBorder {
    @include border-radius-r2;

    border: 1px solid var(--border-soft);
  }
}

.emailLink {
  color: var(--text-link);
}

.errorSubtitle {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.styledErrorMessage {
  width: auto;
}
